import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Input from '../Input';
import Button from '../Button';
import graphFetch from '../../util/graphFetch';
import { DorikLogo } from '../Login/Login';
import { LoginWrap } from '../Login/Login.stc';

const Wrap = styled(LoginWrap)``;

const FormWrap = styled.div`
    width: 400px;
    padding: 30px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
`;

const BackButton = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    color: #fff;
    cursor: pointer;
`;

function RequestPassword(props) {
    const [isLoading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleChange = (setStateFn) => (event) => {
        const { value } = event.target;
        setStateFn(value);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const options = {
            queryName: 'forgotPassword',
            args: {
                email: { type: 'String!', value: email.trim().toLowerCase() },
            },
        };
        const { data } = await graphFetch(options);
        if (data && data.forgotPassword) {
            setMessage('A reset password link has been sent to the email');
        }
        setLoading(false);
    };

    const handleBack = () => {
        window.history.back();
    };

    return (
        <Wrap>
            <BackButton onClick={() => handleBack()}>
                <span>
                    <FontAwesomeIcon
                        fixedWidth
                        icon={['far', 'long-arrow-left']}
                    />{' '}
                    Back
                </span>
            </BackButton>
            <DorikLogo />
            <FormWrap>
                <h4>Enter Your Email</h4>
                <form method="POST" onSubmit={handleSubmit}>
                    <Input
                        type="email"
                        name="email"
                        value={email}
                        className="mb-15"
                        icon={['far', 'envelope']}
                        onChange={handleChange(setEmail)}
                    />
                    <Button
                        disabled={isLoading}
                        fullWidth
                        size="2x"
                        htmlType="submit"
                    >
                        Reset Password
                        {isLoading && (
                            <>
                                {' '}
                                <FontAwesomeIcon
                                    spin
                                    fixedWidth
                                    icon={['far', 'spinner']}
                                />
                            </>
                        )}
                    </Button>
                </form>

                {message && <p>{message}</p>}
            </FormWrap>
        </Wrap>
    );
}

export default RequestPassword;
